<template>
  <div class="fsg-promo-area">
    <div class="branding-item" v-for="(brand, index) in branding" :key="index">
      <div class="branding-image">
        <img class="cover-branding-img" :alt="brand.title" :src="brand.graphic">
      </div>
      <div class="branding-content">
        <div class="branding-title forza-bold">
          {{ brand.title }}
        </div>
        <div class="branding-items">
          <div class="branding-item-row" v-for="(item, itemIndex) in brand.items" :key="itemIndex">
            {{ item }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: "FSGPromoArea",
  computed: {
    ...mapGetters("playbook", ["branding", "isFSGTemplate"]),

  }
}
</script>

<style lang="scss" scoped>
  #app {
    .fsg-promo-area {
      .branding-item {
        display: flex;
        flex-direction: row;
        margin-bottom: 2em;
        .branding-image {
          width: 10em;
          max-height: 6em;
          display: flex;
          justify-items: center;
          align-items: center;
          padding: .5em;
          margin-right: 1em;
          .cover-branding-img {
            max-width: 100%;
            max-height: 100%;
            margin: 0 auto;
          }
        }
        .branding-content {
          display: flex;
          flex-direction: column;

          .branding-title {
            font-weight: bold;
            font-size: 2em;
            text-transform: uppercase;
            // font-style: italic;
            border-bottom: 1px solid;
            margin-bottom: .25em;
            width: 10em;
          }

          .branding-items {
            line-height: 1.5em;
            font-size: 1em;
          }
        }
      }
    }
  }
</style>